/* Varias secciones cargan este archivo. Sin este candado, los clics se
   registrarían dos o tres veces y el acordeón se abriría y cerraría solo. */
if (!window.hgIniciado) {
  window.hgIniciado = true;
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hgIniciar);
  } else {
    hgIniciar();
  }
}

function hgIniciar() {
  var funciones = [
    initReveal, initCountUp, initFaqAccordion,
    initScrollToPedido, initIrAContraentrega, initBarraMovil, initBotonCarrito,
    initGaleriaProducto, initFlechasGaleria, initCatalogoSlider, initHeroSlider, initTilt3D,
    initParallaxFondo, initGiro360, initGiroScroll, initPopupDescuento
  ];
  funciones.forEach(function (fn) {
    try { fn(); } catch (e) { /* un error en una sección no debe tumbar las demás */ }
  });
}

/* Héroe deslizante de la portada: cambia de producto con flechas o puntos */
function initHeroSlider() {
  var secciones = document.querySelectorAll('[data-hero-slider]');
  if (!secciones.length) return;

  secciones.forEach(function (seccion) {
    var track = seccion.querySelector('[data-hero-track]');
    var slides = seccion.querySelectorAll('.hg-hs-slide');
    var prev = seccion.querySelector('[data-hero-prev]');
    var next = seccion.querySelector('[data-hero-next]');
    var puntos = seccion.querySelectorAll('[data-hero-dot]');
    if (!track || slides.length < 2) return;

    var indice = 0;

    var irA = function (i) {
      indice = (i + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + (indice * 100) + '%)';
      puntos.forEach(function (p, idx) {
        p.classList.toggle('hg-hs-punto-activo', idx === indice);
      });
    };

    if (prev) prev.addEventListener('click', function () { irA(indice - 1); });
    if (next) next.addEventListener('click', function () { irA(indice + 1); });
    puntos.forEach(function (p) {
      p.addEventListener('click', function () {
        irA(parseInt(p.getAttribute('data-hero-dot'), 10) || 0);
      });
    });

    /* Deslizar con el dedo en móvil */
    var xInicio = null;
    track.addEventListener('touchstart', function (e) { xInicio = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', function (e) {
      if (xInicio === null) return;
      var diferencia = e.changedTouches[0].clientX - xInicio;
      if (Math.abs(diferencia) > 40) { irA(diferencia < 0 ? indice + 1 : indice - 1); }
      xInicio = null;
    });
  });
}

/* Catálogo de la portada: flechas para deslizar en escritorio */
function initCatalogoSlider() {
  var wraps = document.querySelectorAll('.hg-catalogo-slider-wrap');
  if (!wraps.length) return;

  wraps.forEach(function (wrap) {
    var slider = wrap.querySelector('[data-catalogo-slider]');
    var prev = wrap.querySelector('[data-catalogo-prev]');
    var next = wrap.querySelector('[data-catalogo-next]');
    if (!slider || !prev || !next) return;

    var avanzar = function (direccion) {
      var tarjeta = slider.querySelector('.hg-producto-card');
      var distancia = tarjeta ? tarjeta.getBoundingClientRect().width + 22 : 300;
      slider.scrollBy({ left: distancia * direccion, behavior: 'smooth' });
    };

    prev.addEventListener('click', function () { avanzar(-1); });
    next.addEventListener('click', function () { avanzar(1); });

    var actualizarFlechas = function () {
      var maxScroll = slider.scrollWidth - slider.clientWidth - 4;
      prev.disabled = slider.scrollLeft <= 4;
      next.disabled = slider.scrollLeft >= maxScroll || maxScroll <= 0;
    };

    actualizarFlechas();
    slider.addEventListener('scroll', actualizarFlechas, { passive: true });
    window.addEventListener('resize', actualizarFlechas);
  });
}

/* Galería de la página de producto: cambiar foto al tocar una miniatura */
function initGaleriaProducto() {
  var minis = document.querySelectorAll('.hg-ph-mini');
  var principal = document.getElementById('hg-ph-img');
  if (!minis.length || !principal) return;

  minis.forEach(function (mini) {
    mini.addEventListener('click', function () {
      var url = mini.getAttribute('data-imagen');
      if (!url) return;
      principal.src = url;
      minis.forEach(function (m) { m.classList.remove('hg-mini-activa'); });
      mini.classList.add('hg-mini-activa');
    });
  });
}

/* Flechas flotantes de la galería: avanzan/retroceden entre las mismas fotos de las miniaturas */
function initFlechasGaleria() {
  var minis = document.querySelectorAll('.hg-ph-mini');
  var principal = document.getElementById('hg-ph-img');
  var flechas = document.querySelectorAll('[data-ph-flecha]');
  if (!minis.length || !principal || !flechas.length) return;

  var urls = Array.prototype.map.call(minis, function (m) { return m.getAttribute('data-imagen'); });

  function activarIndice(i) {
    var total = urls.length;
    var idx = ((i % total) + total) % total;
    principal.src = urls[idx];
    minis.forEach(function (m, mi) { m.classList.toggle('hg-mini-activa', mi === idx); });
  }

  flechas.forEach(function (flecha) {
    flecha.addEventListener('click', function () {
      var actual = 0;
      minis.forEach(function (m, mi) { if (m.classList.contains('hg-mini-activa')) actual = mi; });
      var paso = parseInt(flecha.getAttribute('data-ph-flecha'), 10) || 1;
      activarIndice(actual + paso);
    });
  });
}

/* Botón "Añadir al carrito": agrega sin recargar y avisa al usuario */
function initBotonCarrito() {
  var botones = document.querySelectorAll('.hg-btn-carrito');
  if (!botones.length) return;

  botones.forEach(function (boton) {
    boton.addEventListener('click', function () {
      var variante = boton.getAttribute('data-variante');
      if (!variante) return;

      var etiqueta = boton.querySelector('[data-etiqueta]');
      var textoOk = boton.getAttribute('data-texto-ok') || '¡Agregado! Ir al carrito';
      var textoNormal = boton.getAttribute('data-texto-normal') || 'Añadir al carrito';

      /* Si ya se agregó, el segundo clic lleva al carrito */
      if (boton.classList.contains('hg-carrito-listo')) {
        window.location.href = '/cart';
        return;
      }

      boton.disabled = true;
      if (etiqueta) etiqueta.textContent = 'Agregando...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variante, quantity: 1 }] })
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, datos: d }; }); })
        .then(function (res) {
          boton.disabled = false;
          if (res.ok) {
            boton.classList.add('hg-carrito-listo');
            if (etiqueta) etiqueta.textContent = textoOk;
            actualizarBurbujaCarrito();
          } else {
            if (etiqueta) etiqueta.textContent = res.datos.description || 'No disponible';
            boton.classList.add('hg-carrito-error');
            setTimeout(function () {
              boton.classList.remove('hg-carrito-error');
              if (etiqueta) etiqueta.textContent = textoNormal;
            }, 3500);
          }
        })
        .catch(function () {
          boton.disabled = false;
          if (etiqueta) etiqueta.textContent = textoNormal;
        });
    });
  });
}

/* Refresca el numerito del carrito en el encabezado */
function actualizarBurbujaCarrito() {
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (carrito) {
      var burbujas = document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"]');
      burbujas.forEach(function (b) { b.textContent = carrito.item_count; });
      var icono = document.getElementById('cart-icon-bubble');
      if (icono && !icono.querySelector('.cart-count-bubble') && carrito.item_count > 0) {
        var nueva = document.createElement('div');
        nueva.className = 'cart-count-bubble';
        nueva.innerHTML = '<span aria-hidden="true">' + carrito.item_count + '</span>';
        icono.appendChild(nueva);
      }
    })
    .catch(function () {});
}

function initReveal() {
  var els = document.querySelectorAll('.hg-reveal');
  if (!els.length) return;

  var mostrarTodo = function () {
    els.forEach(function (el) { el.classList.add('hg-visible'); });
  };

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion || typeof IntersectionObserver !== 'function') {
    mostrarTodo();
    return;
  }

  /* Respaldo corto: si por lo que sea la animación no se dispara sola (el
     navegador tarda en activar el observador, una extensión lo bloquea,
     etc.), el contenido se muestra de todas formas y no se queda en
     blanco. */
  var respaldo = setTimeout(mostrarTodo, 600);

  try {
    /* Lo que ya está a la vista al cargar la página se muestra de una vez,
       sin esperar animación ni observador — para que nada aparezca en
       blanco al abrir la tienda. */
    els.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) {
        el.classList.add('hg-visible');
      }
    });

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('hg-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) {
      if (!el.classList.contains('hg-visible')) observer.observe(el);
    });
  } catch (e) {
    clearTimeout(respaldo);
    mostrarTodo();
  }
}

function initCountUp() {
  var els = document.querySelectorAll('.hg-cifra[data-target]');
  if (!els.length) return;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var animate = function (el) {
    var target = parseFloat(el.getAttribute('data-target')) || 0;
    var suffix = el.getAttribute('data-suffix') || '';
    if (reduceMotion) { el.textContent = target + suffix; return; }
    var duration = 1400;
    var start = null;
    var step = function (ts) {
      if (!start) start = ts;
      var progress = Math.min((ts - start) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      el.textContent = Math.round(target * eased) + suffix;
      if (progress < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  };
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) { animate(entry.target); observer.unobserve(entry.target); }
    });
  }, { threshold: 0.4 });
  els.forEach(function (el) { observer.observe(el); });
}

function initFaqAccordion() {
  var items = document.querySelectorAll('.hg-faq-item');
  if (!items.length) return;

  var cerrar = function (item) {
    item.classList.remove('hg-faq-abierto');
    var resp = item.querySelector('.hg-faq-respuesta');
    if (resp) resp.style.maxHeight = '';
    var btn = item.querySelector('.hg-faq-pregunta');
    if (btn) btn.setAttribute('aria-expanded', 'false');
  };

  var abrir = function (item) {
    item.classList.add('hg-faq-abierto');
    var resp = item.querySelector('.hg-faq-respuesta');
    if (resp) resp.style.maxHeight = resp.scrollHeight + 40 + 'px';
    var btn = item.querySelector('.hg-faq-pregunta');
    if (btn) btn.setAttribute('aria-expanded', 'true');
  };

  items.forEach(function (item) {
    var btn = item.querySelector('.hg-faq-pregunta');
    if (!btn) return;
    btn.setAttribute('aria-expanded', 'false');
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var estabaAbierto = item.classList.contains('hg-faq-abierto');
      items.forEach(cerrar);
      if (!estabaAbierto) abrir(item);
    });
  });

  window.addEventListener('resize', function () {
    var abierto = document.querySelector('.hg-faq-item.hg-faq-abierto');
    if (abierto) abrir(abierto);
  });
}

/* Cualquier enlace o botón con href="#pedido" baja suavemente al formulario */
function initScrollToPedido() {
  var enlaces = document.querySelectorAll('a[href="#pedido"], a[href*="#pedido"]');
  if (!enlaces.length) return;
  enlaces.forEach(function (a) {
    a.addEventListener('click', function (e) {
      var destino = document.getElementById('pedido');
      if (!destino) return;
      e.preventDefault();
      destino.scrollIntoView({ behavior: 'smooth', block: 'start' });
      var primerCampo = destino.querySelector('input');
      if (primerCampo) {
        setTimeout(function () { primerCampo.focus({ preventScroll: true }); }, 600);
      }
    });
  });
}

/* Botones de "pago contra entrega": si el cliente le da clic es porque ya
   quiere comprar, así que abren de una vez el formulario real de ReleaSIT
   — sin bajar la página ni pasar por ningún paso de más. */
function initIrAContraentrega() {
  var botones = document.querySelectorAll('[data-ir-a-contraentrega]');
  if (!botones.length) return;

  function botonReal() {
    return document.querySelector('.rsi-app-block-container button:not([style*="display: none"]), .rsi-app-block-container a:not([style*="display: none"])');
  }

  botones.forEach(function (a) {
    a.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();

      var real = botonReal();
      if (real) { real.click(); return; }

      var intentos = 0;
      var esperar = setInterval(function () {
        intentos++;
        real = botonReal();
        if (real) { real.click(); clearInterval(esperar); }
        else if (intentos > 15) clearInterval(esperar);
      }, 150);
    });
  });
}

/* Barra fija en móvil con el precio y el botón de pedir */
function initBarraMovil() {
  var barra = document.querySelector('.hg-barra-movil');
  var formulario = document.getElementById('pedido');
  if (!barra) return;
  var mostrar = function () {
    var pasadoHero = window.scrollY > 420;
    var formularioVisible = false;
    if (formulario) {
      var r = formulario.getBoundingClientRect();
      formularioVisible = r.top < window.innerHeight && r.bottom > 0;
    }
    barra.classList.toggle('hg-barra-visible', pasadoHero && !formularioVisible);
  };
  mostrar();
  window.addEventListener('scroll', mostrar, { passive: true });
}

/* Banner de fondo: la foto se mueve más lento que el resto al hacer scroll */
function initParallaxFondo() {
  var fondos = document.querySelectorAll('[data-parallax-fondo]');
  if (!fondos.length) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var ticking = false;

  function actualizar() {
    fondos.forEach(function (fondo) {
      var seccion = fondo.closest('.hg-hs');
      if (!seccion) return;
      var rect = seccion.getBoundingClientRect();
      var centro = rect.top + rect.height / 2 - window.innerHeight / 2;
      var offset = centro * -0.18;
      var limite = rect.height * 0.15;
      if (offset > limite) offset = limite;
      if (offset < -limite) offset = -limite;
      fondo.style.transform = 'translateY(' + offset.toFixed(1) + 'px)';
    });
    ticking = false;
  }

  window.addEventListener('scroll', function () {
    if (!ticking) {
      window.requestAnimationFrame(actualizar);
      ticking = true;
    }
  }, { passive: true });

  actualizar();
}

/* Gira el producto: arrastra para pasar entre las fotos como si fuera un 360 */
function initGiro360() {
  var cajas = document.querySelectorAll('[data-rotar-360]');
  if (!cajas.length) return;

  cajas.forEach(function (caja) {
    var frames = (caja.getAttribute('data-frames-360') || '').split('|').filter(Boolean);
    if (frames.length < 2) return;
    var img = caja.querySelector('img');
    if (!img) return;

    var indice = 0;
    var arrastrando = false;
    var xInicio = 0;
    var pxPorCuadro = 22;
    var pista = caja.querySelector('.hg-ph-360-pista');

    function mostrar(i) {
      indice = ((i % frames.length) + frames.length) % frames.length;
      img.src = frames[indice];
    }

    function empezar(x) {
      arrastrando = true;
      xInicio = x;
      caja.classList.add('hg-ph-360-activo');
    }

    function mover(x) {
      if (!arrastrando) return;
      var delta = x - xInicio;
      if (Math.abs(delta) >= pxPorCuadro) {
        var pasos = Math.trunc(delta / pxPorCuadro);
        mostrar(indice - pasos);
        xInicio = x;
        if (pista) pista.style.opacity = '0';
      }
    }

    function terminar() {
      arrastrando = false;
      caja.classList.remove('hg-ph-360-activo');
    }

    caja.addEventListener('mousedown', function (e) { empezar(e.clientX); e.preventDefault(); });
    window.addEventListener('mousemove', function (e) { mover(e.clientX); });
    window.addEventListener('mouseup', terminar);

    caja.addEventListener('touchstart', function (e) {
      if (!e.touches.length) return;
      empezar(e.touches[0].clientX);
    }, { passive: true });
    caja.addEventListener('touchmove', function (e) {
      if (!e.touches.length) return;
      mover(e.touches[0].clientX);
    }, { passive: true });
    caja.addEventListener('touchend', terminar);
  });
}

/* Gira el producto al hacer scroll — se queda fijo en pantalla mientras rota */
function initGiroScroll() {
  var cajas = document.querySelectorAll('[data-rotar-scroll]');
  if (!cajas.length) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var items = [];
  cajas.forEach(function (caja) {
    var frames = (caja.getAttribute('data-frames-360') || '').split('|').filter(Boolean);
    var img = caja.querySelector('img');
    if (frames.length < 2 || !img) return;
    var galeria = caja.closest('.hg-ph-galeria-fija') || caja.parentElement;
    items.push({ caja: caja, img: img, frames: frames, galeria: galeria, ultimoIndice: -1 });
  });
  if (!items.length) return;

  var ticking = false;

  function actualizar() {
    items.forEach(function (item) {
      var rect = item.galeria.getBoundingClientRect();
      var alto = window.innerHeight;
      /* progreso 0 cuando el elemento entra por abajo, 1 cuando sale por arriba */
      var progreso = (alto - rect.top) / (alto + rect.height);
      progreso = Math.max(0, Math.min(1, progreso));
      /* dos vueltas completas durante el recorrido, para que se sienta el giro */
      var indice = Math.floor(progreso * item.frames.length * 2) % item.frames.length;
      if (indice !== item.ultimoIndice) {
        item.img.src = item.frames[indice];
        item.ultimoIndice = indice;
      }
    });
    ticking = false;
  }

  window.addEventListener('scroll', function () {
    if (!ticking) {
      window.requestAnimationFrame(actualizar);
      ticking = true;
    }
  }, { passive: true });

  actualizar();
}

/* Efecto 3D: la foto del producto se inclina siguiendo el mouse o el dedo */
function initTilt3D() {
  var cajas = document.querySelectorAll('[data-tilt-3d]');
  if (!cajas.length) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  cajas.forEach(function (caja) {
    var maxGrados = 10;

    function mover(xRel, yRel) {
      var tiltY = (xRel - 0.5) * maxGrados * 2;
      var tiltX = (0.5 - yRel) * maxGrados * 2;
      caja.style.setProperty('--tilt-x', tiltX.toFixed(2) + 'deg');
      caja.style.setProperty('--tilt-y', tiltY.toFixed(2) + 'deg');
      caja.style.setProperty('--tilt-scale', '1.04');
    }

    function resetear() {
      caja.style.setProperty('--tilt-x', '0deg');
      caja.style.setProperty('--tilt-y', '0deg');
      caja.style.setProperty('--tilt-scale', '1');
    }

    caja.addEventListener('mousemove', function (e) {
      var rect = caja.getBoundingClientRect();
      mover((e.clientX - rect.left) / rect.width, (e.clientY - rect.top) / rect.height);
    });
    caja.addEventListener('mouseleave', resetear);

    caja.addEventListener('touchmove', function (e) {
      if (!e.touches || !e.touches.length) return;
      var rect = caja.getBoundingClientRect();
      var t = e.touches[0];
      mover((t.clientX - rect.left) / rect.width, (t.clientY - rect.top) / rect.height);
    }, { passive: true });
    caja.addEventListener('touchend', resetear);
  });
}

/* Popup de descuento por correo: aparece pasados unos segundos o al bajar
   la mitad de la página, una sola vez por navegador (o si ya escribió su
   correo antes, nunca más). */
function initPopupDescuento() {
  var popup = document.getElementById('hg-popup-descuento');
  if (!popup) return;

  var CLAVE = 'hg_popup_descuento';
  var guardado = null;
  try { guardado = JSON.parse(localStorage.getItem(CLAVE) || 'null'); } catch (e) { guardado = null; }
  if (guardado && (guardado.convertido || (Date.now() - guardado.visto) < 7 * 24 * 60 * 60 * 1000)) return;

  var segundos = parseInt(popup.getAttribute('data-popup-segundos'), 10) || 10;
  var mostrado = false;

  function mostrar() {
    if (mostrado) return;
    mostrado = true;
    popup.classList.add('hg-popup-activo');
    popup.setAttribute('aria-hidden', 'false');
    try { localStorage.setItem(CLAVE, JSON.stringify({ visto: Date.now(), convertido: false })); } catch (e) {}
  }

  function cerrar() {
    popup.classList.remove('hg-popup-activo');
    popup.setAttribute('aria-hidden', 'true');
  }

  var porTiempo = setTimeout(mostrar, segundos * 1000);

  function porScroll() {
    var progreso = window.scrollY / Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
    if (progreso > 0.4) {
      mostrar();
      window.removeEventListener('scroll', porScroll);
    }
  }
  window.addEventListener('scroll', porScroll, { passive: true });

  popup.querySelectorAll('[data-popup-cerrar]').forEach(function (el) {
    el.addEventListener('click', cerrar);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && popup.classList.contains('hg-popup-activo')) cerrar();
  });

  var form = document.getElementById('hg-popup-form');
  if (!form) return;
  var pasoForm = popup.querySelector('[data-popup-paso="form"]');
  var pasoCodigo = popup.querySelector('[data-popup-paso="codigo"]');

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var boton = form.querySelector('.hg-popup-boton');
    var textoOriginal = boton.textContent;
    boton.disabled = true;
    boton.textContent = 'Enviando...';

    fetch(form.action, { method: 'POST', body: new FormData(form) })
      .then(function () {
        try {
          localStorage.setItem(CLAVE, JSON.stringify({ visto: Date.now(), convertido: true }));
        } catch (err) {}
        if (pasoForm) pasoForm.hidden = true;
        if (pasoCodigo) pasoCodigo.hidden = false;
      })
      .catch(function () {
        boton.disabled = false;
        boton.textContent = textoOriginal;
        alert('No se pudo enviar tu correo. Inténtalo de nuevo.');
      });
  });

  var botonCopiar = popup.querySelector('[data-popup-copiar]');
  if (botonCopiar) {
    botonCopiar.addEventListener('click', function () {
      var codigo = popup.getAttribute('data-popup-codigo') || '';
      var textoOriginal = botonCopiar.textContent;
      var marcarCopiado = function () {
        botonCopiar.textContent = '¡Copiado!';
        botonCopiar.classList.add('hg-popup-copiado');
        setTimeout(function () {
          botonCopiar.textContent = textoOriginal;
          botonCopiar.classList.remove('hg-popup-copiado');
        }, 1800);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(codigo).then(marcarCopiado).catch(function () {});
      } else {
        marcarCopiado();
      }
    });
  }
}
